import { CalculationFooterComponent } from "./calculation-footer.component";

export const CalculationFooter = CalculationFooterComponent;